import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-16">
        <div>
          <SectionHeading
            index="07"
            eyebrow="FAQ"
            title="常见问题"
            desc="关于入口、地址与下载，这里集中回答最常被问到的几个问题。"
          />
          <div className="mt-8 p-5 rounded-lg bg-primary-50 border border-primary-100">
            <span className="flex items-center gap-2 font-heading font-bold text-sm text-primary-800">
              <i className="ri-bookmark-line" aria-hidden="true"></i>
              还没收藏？
            </span>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              把本页加入书签，之后入口怎么变都能从这里找回最新地址。
            </p>
            <a
              href="#top"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
              返回顶部收藏
            </a>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-200 bg-background-100' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading font-bold text-sm md:text-base text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-primary-600 transition-transform ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}